module.exports = __webpack_public_path__ + "static/cascade-sea-69cc78b9623c7c3af66565d696d51417.png";